import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import type { InstantBonus } from '@swf/core/types/InstantBonus';
import { isActive } from '@swf/core/utils/casino';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import sharedStyles from '../InstantBonusSharedTile.scss';
import RegularBonus from '../RegularBonus/RegularBonus';
import WagerBonus from '../WagerBonus/WagerBonus';

import {
  TXTACL_N0_Bets,
  TXTCLI_Active,
  TXTCLI_N0_Redemption_Points,
  TXTCLI_Paused,
  TXTWCL_Funds_Wagered,
  TXTWCL_Not_Active
} from './InstantBonusTile.messages.json';

interface Props {
  ib: InstantBonus;
  compact?: boolean;
  onClick?(): void;
}

const InstantBonusTile: React.FC<Props> = ({ ib, compact = false, onClick }) => {
  const amount = (ib.pointsUsed / ib.points) * 100;
  const inactive = !isActive(ib);
  const progressStyle = inactive ? {} : { width: amount > 0 ? amount + '%' : '0.5rem' };
  const pointText = ib.useBets
    ? TXTACL_N0_Bets
    : ib.useWager
    ? TXTWCL_Funds_Wagered
    : TXTCLI_N0_Redemption_Points;

  return (
    <div
      className={classNames(sharedStyles.container, {
        [sharedStyles.compact]: compact,
        [sharedStyles.splitWager]: ib.splitWager
      })}
      onClick={onClick}
    >
      <div
        className={classNames(sharedStyles.title, {
          [sharedStyles.disabled]: inactive || ib.paused
        })}
      >
        {ib.title}
      </div>
      <div
        className={classNames(sharedStyles.status, {
          [sharedStyles.paused]: ib.paused,
          [sharedStyles.disabled]: inactive && !ib.paused
        })}
      >
        <div
          className={classNames(sharedStyles.statusDot, {
            [sharedStyles.paused]: ib.paused,
            [sharedStyles.disabled]: inactive && !ib.paused
          })}
        />
        <Translation
          {...(ib.paused ? TXTCLI_Paused : inactive ? TXTWCL_Not_Active : TXTCLI_Active)}
          tagName="span"
        />
      </div>
      {ib.splitWager ? <WagerBonus ib={ib} compact={compact} /> : <RegularBonus ib={ib} />}
      <div
        className={classNames(sharedStyles.redemption, {
          [sharedStyles.disabled]: inactive || ib.paused
        })}
      >
        <div className={sharedStyles.text}>
          <Translation tagName="span" {...pointText} values={{ 0: '' }} />
        </div>
        <div className={sharedStyles.amount}>
          <span>
            {ib.useWager ? (
              <>
                <CurrencyAmount currency={ib.currency} value={ib.pointsUsed} />
                <span>/</span>
                <CurrencyAmount currency={ib.currency} value={ib.points} />
              </>
            ) : (
              <span>
                {ib.pointsUsed} / {ib.points}
              </span>
            )}
          </span>
        </div>
        <div
          className={classNames(sharedStyles.progressBar, {
            [sharedStyles.disabled]: inactive || ib.paused
          })}
        >
          <div style={progressStyle} />
        </div>
      </div>
    </div>
  );
};

export default InstantBonusTile;
